export const truncateFileName = (fileName: string, maxLength: number, tail = 8) => {
  const len = fileName.length;

  if (len > maxLength) {
    return `${fileName.substring(0, maxLength - tail)}...${fileName.substring(len - tail)}`;
  }

  return fileName;
};
